import { BrickTreeComponent } from './BrickTreeComponent';

export default BrickTreeComponent;